import { render, staticRenderFns } from "./ESLProductInfo.vue?vue&type=template&id=35973389&scoped=true&"
import script from "./ESLProductInfo.vue?vue&type=script&lang=js&"
export * from "./ESLProductInfo.vue?vue&type=script&lang=js&"
import style0 from "./ESLProductInfo.vue?vue&type=style&index=0&id=35973389&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35973389",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})


/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/-36BVGaF/0/applicationg/aims-dashboard/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('35973389')) {
      api.createRecord('35973389', component.options)
    } else {
      api.reload('35973389', component.options)
    }
    module.hot.accept("./ESLProductInfo.vue?vue&type=template&id=35973389&scoped=true&", function () {
      api.rerender('35973389', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Reports/ESLProductInfo.vue"
export default component.exports